module.exports = __webpack_public_path__ + "img/main.0f7f8500.svg";